












































import Component from 'vue-class-component'
import Dialog from '@/shared/dialog/dialog'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import { Injector } from '@/config/dependency-injection'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { CREATE_ACCOUNT } from '@/business/administration/store/types'
import { TypedForm } from '@/shared/forms/typed-form'
import { Hooks } from '@/shared/interfaces/hooks'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import { CreateAccount } from '@/api/generated'
import {
  CreateAccountForm,
  createAccountFormMapping,
} from '@/business/administration/components/create-account/create-account-form'
import RespondecoDefaultModalFooter from '@/shared/components/prompt-dialog/respondeco-default-modal-footer.vue'
import { AdministrationModule } from '@/business/administration/store/administration-module'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import { slugEmail } from '@/shared/utils/slug-email'
import { NotificationService } from '@/shared/services/notification-service'
import RespondecoTypedForm from '@/shared/components/respondeco-typed-form.vue'
import RespondecoFormGroup from '@/shared/components/respondeco-form-group.vue'

@Component({
  name: 'create-account-dialog',
  components: {
    RespondecoFormGroup,
    RespondecoTypedForm,
    RespondecoValidationFeedback,
    RespondecoDefaultModalFooter,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    RespondecoForm,
  },

  data() {
    return {
      form: undefined,
    }
  },
})
export default class CreateAccountDialog extends Dialog<void> implements Hooks {
  public form!: TypedForm<CreateAccount, CreateAccountForm>

  private adminModule = Injector.get(AdministrationModule)
  private loaderHelper = Injector.get(LoaderHelper)
  private notificationService = Injector.get(NotificationService)

  public get submitting(): boolean {
    return this.loaderHelper.isLoading(CREATE_ACCOUNT)
  }

  public mounted() {
    this.form = new TypedForm<CreateAccount, CreateAccountForm>(createAccountFormMapping(), this)

    this.$watch(
      () => this.form.value.name,
      (value, old) => {
        let replaceEmail: boolean = true

        if (old != null) {
          const checkAgainst = `${slugEmail(old)}@managed.respondeco.org`

          if (this.form.value.email !== checkAgainst) {
            replaceEmail = false
          }
        }

        if (replaceEmail) {
          this.form.patch({
            email: `${slugEmail(value)}@managed.respondeco.org`,
          })
        }
      }
    )
  }

  public submit(): void {
    const { email, name } = this.form.serialize()

    this.adminModule
      .createOrganisation({
        email,
        name,
      })
      .then(() => {
        this.dialogRef.close()
      })
      .catch(
        this.notificationService.errorHandler({
          409: this.$t('administration.create_account.errors.organisation_exists'),
        })
      )
  }

  public validations() {
    return this.form.validations()
  }
}
